import * as React from 'react';

import _t from 'i18n!nls/widget-simulator';

class NotFound extends React.Component {
  render() {
    return (
      <div className="rc-NotFound">
        <h1>{_t('404 Not Found')}</h1>
        <p>{_t("Sorry, we couldn't find the page you requested.")}</p>
      </div>
    );
  }
}

export default NotFound;
